const siteMetadata = {
  title: "Studio: Hands-on Classes From The World's Best",
  description:
    "Learn from the world’s best as they take you into their studios and teach you everything they do behind the scenes. Watch their real, start-to-finish processes. ",
  companyName: "Studio",
  siteUrl: "https://studio.com",
  siteLogo:
    "https://res.cloudinary.com/monthly/image/upload/q_auto:best,f_auto/v1649719544/monthly-admin-images/homepage/studio-og.jpg",
  twitter: "https://twitter.com/wearestudio",
  twitterHandle: "@wearestudio",
  facebook: "https://www.facebook.com/studio/",
  instagram: "https://www.instagram.com/studio",
  linkedin: "https://www.linkedin.com/company/studio-official/",
  tiktok: "https://www.tiktok.com/@studio",
};

export default siteMetadata;
